module.exports = __webpack_public_path__ + "img/big-screen-pc.c870aee2.jpg";